import type { RdxSagasConfig } from '../../types'

export const DEFAULT_REDUX_SAGAS_CONFIG: RdxSagasConfig = {
  enabled: true,
  options: undefined,
}
